import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'dva';
import styles from './GHWidgetBar.module.scss';
import X from '../../../assets/svg/Feather/X';
import actions from './actions';

const GHWidgetBar = (props) => {
  const clearActiveTool = () => {
    props.clearActiveTool();
  };

  if (!props.isMapReady) return null;

  return (
    <div className={styles.widgetBar}>
      <div className={styles.buttonContainer}>
        {props.children}
      </div>
      {props.activeTool != null ? (
        <button
          onClick={clearActiveTool}
          className={[
            'esri-widget--button',
            'esri-interactive',
            styles.cancelButton
          ].join(' ')}
          title="Clear Measurements"
        >
          <X width={20} height={20} color='#ffffff' />
        </button>
      ) : null}
    </div>
  );
};

GHWidgetBar.propTypes = {
  activeTool: PropTypes.string,
  children: PropTypes.any,
  isMapReady: PropTypes.bool,
  map: PropTypes.any,
  view: PropTypes.any,
  //actions
  clearActiveTool: PropTypes.func
};

export default connect((model) => {
  const { activeTool, isMapReady, isUpdatingLocation } = model.map
  return {
    activeTool,
    isMapReady,
    isUpdatingLocation,
  };
}, actions)(GHWidgetBar);
